import React from 'react'
import { useLocation, Outlet } from 'react-router-dom'
// @mui
import {
	Box, Link, Container, Typography, Stack,
} from '@mui/material'
// components
import Logo from '../../components/Logo'
//
import MainFooter from './LowChromeFooter'
import MainHeader from './LowChromeHeader'
import HubSpot from '../../components/HubSpot'

// ----------------------------------------------------------------------

export default function MainLayout() {
	const { pathname } = useLocation()

	const isHome = pathname === '/'

	return (
		<Stack sx={{ minHeight: 1 }}>
			<MainHeader />

			<Outlet />

			<Box sx={{ flexGrow: 1 }} />

		</Stack>
	)
}
